// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import './Newsroom.css';

// const Newsroom = () => {
//     const [activeFilter, setActiveFilter] = useState('all');

//     const newsCategories = [
//         { id: 'all', label: 'All News' },
//         { id: 'press', label: 'Press Releases' },
//         { id: 'product', label: 'Product Launches' },
//         { id: 'events', label: 'Events' },
//         { id: 'industry', label: 'Industry Updates' }
//     ];

//     const newsItems = [
//         {
//             id: 1,
//             category: 'press',
//             title: 'ProCart Expands Operations to 10 New Cities',
//             date: 'June 15, 2025',
//             excerpt: 'ProCart announces expansion of its operations and same-day delivery services to 10 additional cities across India.',
//             image: 'expansion'
//         },
//         {
//             id: 2,
//             category: 'product',
//             title: 'New Arduino Pro Line Exclusively at ProCart',
//             date: 'June 10, 2025',
//             excerpt: 'ProCart becomes the exclusive distributor for the new Arduino Pro line of development boards in India.',
//             image: 'arduino'
//         },
//         {
//             id: 3,
//             category: 'events',
//             title: 'Join Us at TechMaker Expo 2025',
//             date: 'June 8, 2025',
//             excerpt: 'ProCart will be showcasing the latest electronics components and hosting workshops at TechMaker Expo 2025.',
//             image: 'expo'
//         },
//         {
//             id: 4,
//             category: 'industry',
//             title: 'The Future of IoT: Insights from Industry Leaders',
//             date: 'June 5, 2025',
//             excerpt: 'ProCart\'s research team shares insights on the future of IoT and smart home technologies based on industry trends.',
//             image: 'iot',
//         },
//         {
//             id: 5,
//             category: 'press',
//             title: 'ProCart Partners with Leading Technical Institutes',
//             date: 'June 1, 2025',
//             excerpt: 'New educational partnership program will provide discounted components to engineering students across the country.',
//             image: 'education'
//         },
//         {
//             id: 6,
//             category: 'product',
//             title: 'Introducing the ProMaker Kit Series',
//             date: 'May 25, 2025',
//             excerpt: 'ProCart launches its own line of project kits for beginners and advanced makers, featuring curated components and tutorials.',
//             image: 'kit'
//         }
//     ];

//     const filteredNews = activeFilter === 'all'
//         ? newsItems
//         : newsItems.filter(item => item.category === activeFilter);

//     return (
//         <div className="newsroom-container">
//             <div className="back-to-home-wrapper">
//                 <Link to="/" className="back-to-home-link">
//                     <svg
//                         className="back-arrow"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                         xmlns="http://www.w3.org/2000/svg"
//                     >
//                         <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth="2"
//                             d="M15 19l-7-7 7-7"
//                         />
//                     </svg>
//                     Back to Home
//                 </Link>
//             </div>

//             <div className="newsroom-header">
//                 <h1>ProCart Newsroom</h1>
//                 <p className="newsroom-tagline">Stay updated with the latest from ProCart</p>
//                 <p className="newsroom-description">
//                     Official news, product announcements, and updates from India's leading electronics components provider.
//                 </p>
//             </div>

//             <div className="featured-news">
//                 <div className="featured-news-content">
//                     <span className="featured-label">Featured Story</span>
//                     <h2>ProCart Launches Next-Day Delivery for All Major Cities</h2>
//                     <p className="featured-date">June 16, 2025</p>
//                     <p className="featured-excerpt">
//                         Starting today, customers in all major Indian cities can enjoy next-day delivery on thousands of electronics components, making ProCart the fastest electronics supplier in the country.
//                     </p>
//                     <button className="read-more-btn">Read Full Story</button>
//                 </div>
//             </div>

//             <div className="news-filter">
//                 <div className="filter-buttons">
//                     {newsCategories.map(category => (
//                         <button
//                             key={category.id}
//                             className={`filter-btn ${activeFilter === category.id ? 'active' : ''}`}
//                             onClick={() => setActiveFilter(category.id)}
//                         >
//                             {category.label}
//                         </button>
//                     ))}
//                 </div>
//             </div>

//             <div className="news-grid">
//                 {filteredNews.map(news => (
//                     <div className="news-card" key={news.id}>
//                         <div className={`news-image ${news.image}`}></div>
//                         <div className="news-content">
//                             <div className="news-category-badge">{newsCategories.find(c => c.id === news.category).label}</div>
//                             <div className="news-date">
//                                 <i className="calendar-icon"></i>
//                                 {news.date}
//                             </div>
//                             <h3 className="news-title">{news.title}</h3>
//                             <p className="news-excerpt">{news.excerpt}</p>

//                         </div>
//                     </div>
//                 ))}
//             </div>

//             <div className="media-contact">
//                 <h2>Media Contact</h2>
//                 <div className="contact-card">
//                     <div className="contact-info">
//                         <h3>Press Inquiries</h3>
//                         <p><strong>Email:</strong> press@procart.in</p>
//                         <p><strong>Phone:</strong> +91 9988776655</p>
//                         <p>For media inquiries, please contact our press team. We aim to respond within 24 hours.</p>
//                     </div>

//                 </div>
//             </div>

//             <div className="newsletter-signup">
//                 <div className="newsletter-content">
//                     <h2>Stay Informed</h2>
//                     <p>Subscribe to our newsletter to receive the latest news and updates directly in your inbox.</p>
//                     <div className="newsletter-form">
//                         <input type="email" placeholder="Enter your email" />
//                         <button className="subscribe-btn">Subscribe</button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Newsroom;



import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getFirestore, collection, getDocs, query, orderBy, doc, getDoc } from 'firebase/firestore';
import './Newsroom.css';
import { FaArrowLeft, FaSpinner, FaCalendarAlt, FaClock, FaTag } from 'react-icons/fa';

const Newsroom = () => {
    const [activeFilter, setActiveFilter] = useState('all');
    const [newsItems, setNewsItems] = useState([]);
    const [newsroomSettings, setNewsroomSettings] = useState({
        title: 'ProCart Newsroom',
        tagline: 'Stay updated with the latest from ProCart',
        description: 'Official news, product announcements, and updates from India\'s leading electronics components provider.',
        featuredStory: {
            title: 'ProCart Launches Next-Day Delivery for All Major Cities',
            date: 'June 16, 2025',
            excerpt: 'Starting today, customers in all major Indian cities can enjoy next-day delivery on thousands of electronics components, making ProCart the fastest electronics supplier in the country.',
        },
        mediaContact: {
            email: 'press@procart.in',
            phone: '+91 9988776655',
            info: 'For media inquiries, please contact our press team. We aim to respond within 24 hours.'
        },
        categories: [
            { id: 'press', label: 'Press Releases' },
            { id: 'product', label: 'Product Launches' },
            { id: 'events', label: 'Events' },
            { id: 'industry', label: 'Industry Updates' }
        ]
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Add all news category at the beginning
    const allNewsCategories = [
        { id: 'all', label: 'All News' },
        ...newsroomSettings.categories
    ];

    // Firestore reference
    const db = getFirestore();
    const newsCollection = collection(db, 'news');

    useEffect(() => {
        const fetchNewsData = async () => {
            try {
                // First get newsroom settings
                const settingsDoc = await getDoc(doc(db, 'settings', 'newsroom'));
                if (settingsDoc.exists()) {
                    setNewsroomSettings({
                        ...newsroomSettings,
                        ...settingsDoc.data()
                    });
                }
                
                // Then get news items sorted by date (newest first)
                const newsQuery = query(newsCollection, orderBy('date', 'desc'));
                const querySnapshot = await getDocs(newsQuery);
                
                const newsData = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                
                setNewsItems(newsData);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching news data:', error);
                setError(error.message);
                setLoading(false);
            }
        };

        fetchNewsData();
    }, []);

    const filteredNews = activeFilter === 'all'
        ? newsItems
        : newsItems.filter(item => item.category === activeFilter);

    if (loading) {
        return (
            <div className="newsroom-container loading-container">
                <div className="blog-header">
                          <Link to="/" className="back-link">
                            <FaArrowLeft /> Back to Home
                          </Link>
                        </div>
                <div className="loading-section">
                    <div className="loading-spinner">
                        <FaSpinner className="spinner-icon" />
                    </div>
                    <p>Loading newsroom content...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="newsroom-container error-container">
                 <div className="blog-header">
                          <Link to="/" className="back-link">
                            <FaArrowLeft /> Back to Home
                          </Link>
                        </div>
                <div className="error-section">
                    <h2>Error Loading Content</h2>
                    <p>We're having trouble loading the newsroom content. Please try refreshing the page.</p>
                    <button onClick={() => window.location.reload()}>Refresh Page</button>
                </div>
            </div>
        );
    }

    return (
        <div className="newsroom-container">
             <div className="blog-header">
                          <Link to="/" className="back-link">
                            <FaArrowLeft /> Back to Home
                          </Link>
                        </div>

            <div className="newsroom-header">
                <h1>{newsroomSettings.title}</h1>
                <p className="newsroom-tagline">{newsroomSettings.tagline}</p>
                <p className="newsroom-description">
                    {newsroomSettings.description}
                </p>
            </div>

            <div className="featured-news">
                <div className="featured-news-content">
                    <span className="featured-label">Featured Story</span>
                    <h2>{newsroomSettings.featuredStory.title}</h2>
                    <p className="featured-date">{newsroomSettings.featuredStory.date}</p>
                    <p className="featured-excerpt">
                        {newsroomSettings.featuredStory.excerpt}
                    </p>
                  
                </div>
            </div>

            <div className="news-filter">
                <div className="filter-buttons">
                    {allNewsCategories.map(category => (
                        <button
                            key={category.id}
                            className={`filter-btn ${activeFilter === category.id ? 'active' : ''}`}
                            onClick={() => setActiveFilter(category.id)}
                        >
                            {category.label}
                        </button>
                    ))}
                </div>
            </div>

            <div className="news-grid">
                {filteredNews.length === 0 ? (
                    <div className="no-news-message">No news items found in this category.</div>
                ) : (
                    filteredNews.map(news => (
                        <div className="news-card" key={news.id}>
                            {news.imageURL ? (
                                <div className="news-image" style={{ backgroundImage: `url(${news.imageURL})` }}></div>
                            ) : news.image ? (
                                <div className={`news-image ${news.image}`}></div>
                            ) : (
                                <div className="news-image default-image"></div>
                            )}
                            <div className="news-content">
                                <div className="news-category-badge">
                                    {newsroomSettings.categories.find(c => c.id === news.category)?.label || news.category}
                                </div>
                                <div className="news-date">
                                    <i className="calendar-icon"></i>
                                    {news.date}
                                </div>
                                <h3 className="news-title">{news.title}</h3>
                                <p className="news-excerpt">{news.excerpt}</p>
                            </div>
                        </div>
                    ))
                )}
            </div>

            <div className="media-contact">
                <h2>Media Contact</h2>
                <div className="contact-card">
                    <div className="contact-info">
                        <h3>Press Inquiries</h3>
                        <p><strong>Email:</strong> {newsroomSettings.mediaContact.email}</p>
                        <p><strong>Phone:</strong> {newsroomSettings.mediaContact.phone}</p>
                        <p>{newsroomSettings.mediaContact.info}</p>
                    </div>
                </div>
            </div>

            {/* <div className="newsletter-signup">
                <div className="newsletter-content">
                    <h2>Stay Informed</h2>
                    <p>Subscribe to our newsletter to receive the latest news and updates directly in your inbox.</p>
                    <div className="newsletter-form">
                        <input type="email" placeholder="Enter your email" />
                        <button className="subscribe-btn">Subscribe</button>
                    </div>
                </div>
            </div> */}
        </div>
    );
};

export default Newsroom;